import { useState, useEffect } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_LIST_MEDIA_MAPPED } from "../../routes";

export default function useGetNotMappedBisList(auto = false, filters = {}) {
  const [mediaMappingList, setMediaMappingList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getNotMappedBisList = (userFilters = {}, showLoader = true) => {
    setIsLoading(showLoader);

    const rawPayload = {
      includeMapped: false,
      bisPublisherId: userFilters.bisPublisherId,
      bisPublisherLabel: userFilters.bisPublisherLabel,
      displayTypeId: userFilters.displayTypeId,
      dataProviderId: userFilters.dataProviderId,
    };

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, v]) => v !== undefined && v !== null && v !== "",
      ),
    );

    return Api.post(API_ROUTE_LIST_MEDIA_MAPPED, payload)
      .then((res) => {
        const data = res?.data?.data;
        setMediaMappingList(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        setMediaMappingList([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (auto) {
      getNotMappedBisList(filters);
    }
  }, [auto, JSON.stringify(filters)]);

  return {
    mediaMappingList,
    getNotMappedBisList,
    isLoading,
  };
}
